// Session expiry is an absolute timestamp in milliseconds, as returned by login.
export function watchSessionExpiry(expiresAt, onExpire) {
  if (typeof expiresAt !== "number" || !Number.isFinite(expiresAt)) return () => {};
  let timer;
  let expired = false;
  const check = () => {
    clearTimeout(timer);
    if (expired) return;
    const remaining = expiresAt - Date.now();
    if (remaining <= 0) { expired = true; onExpire(); }
    else timer = setTimeout(check, Math.min(remaining, 2 ** 31 - 1));
  };
  // Check again when a suspended/background tab becomes visible.
  globalThis.document?.addEventListener("visibilitychange", check);
  check();
  return () => {
    expired = true;
    clearTimeout(timer);
    globalThis.document?.removeEventListener("visibilitychange", check);
  };
}
